export default "__VITE_PUBLIC_ASSET__dcf327c4__"